import type { FC, ReactNode } from 'react'

import { Instagram, Twitter, Youtube } from 'lucide-react'

import { MarathonMark } from '@/components/landing/marathon-mark'
import { footerColumns } from '@/constants/marathon'

export const SiteFooter: FC = (): ReactNode => {
    return (
        <footer className='border-t border-white/10 bg-[#0b0b0d]'>
            <div className='mx-auto max-w-7xl px-5 py-16 sm:px-8'>
                <div className='grid gap-12 lg:grid-cols-[1.5fr_1fr_1fr_1fr_1fr]'>
                    <div>
                        <div className='flex items-center gap-2.5 text-white'>
                            <MarathonMark className='h-5 w-5' />
                            <span className='text-sm font-bold tracking-[0.22em]'>
                                MARATHON
                            </span>
                        </div>
                        <p className='mt-5 max-w-xs text-sm leading-relaxed text-white/50'>
                            Run with intention. Track every mile, train smarter, and
                            find your pack.
                        </p>
                        <div className='mt-6 flex gap-3'>
                            {[Instagram, Twitter, Youtube].map((Icon, i) => (
                                <a
                                    key={i}
                                    href='#'
                                    className='flex h-9 w-9 items-center justify-center rounded-full border border-white/10 text-white/60 transition-colors hover:border-white/30 hover:text-white'
                                    aria-label='Social link'
                                >
                                    <Icon className='h-4 w-4' />
                                </a>
                            ))}
                        </div>
                    </div>

                    {footerColumns.map((column) => (
                        <div key={column.title}>
                            <h3 className='text-[11px] font-bold tracking-[0.18em] text-white/70'>
                                {column.title.toUpperCase()}
                            </h3>
                            <ul className='mt-5 flex flex-col gap-3'>
                                {column.links.map((link) => (
                                    <li key={link}>
                                        <a
                                            href='#'
                                            className='text-sm text-white/50 transition-colors hover:text-white'
                                        >
                                            {link}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                <div className='mt-14 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row'>
                    <p className='text-xs text-white/40'>
                        © {new Date().getFullYear()} Marathon. All rights reserved.
                    </p>
                    <p className='text-xs text-white/40'>
                        Made for runners, everywhere.
                    </p>
                </div>
            </div>
        </footer>
    )
}
